import { cardeal } from './api';

const recuperaDataAtual = () => {
  const data = new Date();
  const dataLocal = data.toLocaleDateString('pt');

  const dia = dataLocal.split('/')[0];
  const mes = dataLocal.split('/')[1];
  const ano = dataLocal.split('/')[2];

  return `${ano}-${`0${mes}`.slice(-2)}-${`0${dia}`.slice(-2)}`;
};

export class BeneficiariosService {
  getBeneficiarios = (matricula, plano) => {
    return cardeal.get('ObterBeneficiariosParticipante', {
      params: {
        matricula,
        plano,
        data: recuperaDataAtual(),
      },
    });
  };
}
